import { displayAdminsAccessConfig } from "./display-admins-access-config";
import { createHrAdmin } from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";
import { logError } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function addAdminsAccess(email, password) {
  try {
    await createHrAdmin(email, password).then(() =>
      displayAdminsAccessConfig()
    );
    showSuccessMessage(
      translate("configuration-section.access-created-successfully")
    );
  } catch (e) {
    logError(e, `Error to create hr-admin access for ${email}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
